import axios from '../utils/axios'

export const login = async (email: string, password: string) => {
    try {
        const res = await axios.post('users/login', {email, password});
        return res;
    } catch (error) {
        throw error;
    }
}

export const resetPassword = async (email: string) => {
    try {
        const res = await axios.post(`users/password/reset`, {email});
        return res;
    } catch (error) {
        throw error;
    }
}

export const changePassword = async (email: string, verificationCode: string, password: string) => {
    try {
        const res = await axios.post(`users/password/reset/confirm`, {email, verificationCode, password});
        return res;
    } catch (error) {
        throw error;
    }
}

export const getMe = async () => {
    try {
        const res = await axios.get('users/me');
        return res;
    } catch (error) {
        throw error;
    }
}

export const verifyEmailCode = async (code: string, email: string) => {
    try {
        const response = await axios.post('/users/verify-email-code', {
            code,
            email
        });
        return response.data.data;
    } catch (error) {
        throw error;
    }
};

export const resendEmailCode = async (email: string) => {
    try {
        const response = await axios.post('/users/resend-email-code', {
            email
        });
        return response.data;
    } catch (error) {
        throw error;
    }
};